
















import Vue from 'vue';

export default Vue.extend({
  props: {
    options: { type: Array },
    value: { type: String },
    hasError: {
      type: Boolean,
    },
  },
  methods: {
    onChange: function (value: string | null) {
      if (value === '') {
        value = null;
      }
      this.$emit('input', value);
    },
  },
});
